import { render, staticRenderFns } from "./VersionTip.vue?vue&type=template&id=b40e1f96&scoped=true"
import script from "./VersionTip.vue?vue&type=script&lang=ts"
export * from "./VersionTip.vue?vue&type=script&lang=ts"
import style0 from "./VersionTip.vue?vue&type=style&index=0&id=b40e1f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e1f96",
  null
  
)

export default component.exports